import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import classnames from 'classnames'
import { indexMap } from '@helpers'
import './BranchOpeningHours.module.scss'

const BranchOpeningHours = ({ days, current, shortNames }) => (
  <div styleName={classnames('openingHours', { isEmbeded: shortNames })}>
    <h4>Our opening hours...</h4>
    <div styleName='table'>
      {indexMap(
        (row, index) => (
          <div styleName={classnames('row', { current: R.prop('value', row) === current })} key={index}>
            <div styleName='day'>
              <span styleName='long'>{R.prop(shortNames ? 'dayShort' : 'day', row)}</span>
              <span styleName='short'>{R.prop('dayShort', row)}</span>
            </div>
            <div styleName='time'>{R.prop('time', row) || 'Closed'}</div>
          </div>
        ),
        days
      )}
    </div>
  </div>
)

BranchOpeningHours.propTypes = {
  days: PropTypes.array,
  current: PropTypes.number.isRequired,
  shortNames: PropTypes.bool
}

BranchOpeningHours.defaultProps = {
  days: [],
  shortNames: false
}

export default BranchOpeningHours



// WEBPACK FOOTER //
// ./src/components/BranchOpeningHours/BranchOpeningHours.js